<template>
    <v-tab-item :value="LIVE.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">라이브(오프라인) <br class="d-none d-md-block"/>경매</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <p class="page-text">라이브경매는 서면(서류 및 온라인 신청), 전화, 현장 응찰 등 3가지 방법으로 참여 가능합니다.</p>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">현장응찰 (In Person)</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>라이브경매는 서면(서류 및 온라인 신청), 전화, 현장 응찰 등 3가지 방법으로 참여 가능합니다. </span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">서면응찰 (Absentee Bidding)</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>사전에 &lt;서면응찰 등록 신청서&gt; 작성으로 응찰하는 방법입니다.</span></li>
                                    <li><em>-</em><span>경매 전에, 원하는 작품 응찰의 최고한도 금액을 기재하여 제출해 주시면, 경매당일 담당직원이 서면응찰 또는 대리응찰로 경매를 참여하여드립니다.</span></li>
                                    <li><em>-</em><span>현장에서 응찰이 발생하더라도 서면응찰이 존재할 경우, 서면응찰에 우선권이 주어집니다.</span></li>
                                    <li><em>-</em><span>서면 응찰 신청은 방문 접수 또는 케이옥션 홈페이지에서 가능합니다.</span></li>
                                    <li><em>-</em><span>서면 응찰 신청은 경매 당일 1시간 전에 마감됩니다. </span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">전화응찰 (Telephone Bidding)</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>경매가 진행될 때 담당직원과의 전화통화로 실시간 응찰하는 방법입니다.</span></li>
                                    <li><em>-</em><span>사전에 당사로 전화응찰을 신청하시면, 경매 당일 담당 직원과 전화 통화를 통하여 실시간으로 대리 응찰을 진행할 수 있습니다.</span></li>
                                    <li><em>-</em><span>전화 응찰 신청은 경매 당일 1시간 전에 마감됩니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">낙찰 우선 순위 (오프라인)</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>내정가 이상으로 최고가를 제시한 응찰자에게 경매작품이 낙찰되며, 동일 금액의 경우 아래 기준에 따라 낙찰이 결정됩니다.</span></li>
                                    <li><em>-</em><span>현장, 서면, 전화응찰자가 동일한 금액으로 경합할 경우에는 서면 응찰 &gt; 현장 응찰 &gt; 전화 응찰 순으로 우선 순위가 주어집니다.</span></li>
                                    <li><em>-</em><span>서면 응찰자 중 동일한 금액이 있을 경우, 먼저 접수된 응찰이 우선순위를 가집니다.</span></li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { LIVE } = HOW_TO_BID_TABS;
export default {
    data() {
        return {
            LIVE,
        };
    },
};
</script>

<style></style>
